import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class InventoryDetailModalStyles extends CommonComponentStyle {
  TitleWrapper = styled.div`
    padding-top: 8px;
  `;

  Title = styled.p`
    font-weight: 700;
    font-size: 16px;
    margin: 8px 16px;
  `;

  Text = styled.p`
    font-size: 14px;
    margin: 22px;
  `;

  QtyErrorText = styled.p`
    color: ${this.colors.PRIMARY_RED};
    font-size: 12px;
    text-align: end;
    margin: 0 32px 0 0;
  `;

  FieldRowWrapper = styled(Grid)`
    padding: 12px 16px;
    width: 150px;
  `;

  InfoColumnWrapper = styled(Grid)`
    padding: 12px 16px;
    width: 150px;
    align-items: center;
  `;

  FooterWrapper = styled.div`
    text-align: center;
    padding: 16px;
  `;

  OKButton = styled(this.PrimaryButton)`
    margin: 0 8px !important;
    width: 40% !important;
  `;

  CancelButton = styled(this.SecondaryButton)`
    margin: 0 8px !important;
    width: 40% !important;
  `;

  RemoveButton = styled(this.RedButtonText)`
    font-size: 14px !important;
  `;
}

export const InventoryDetailModalStyle = new InventoryDetailModalStyles();
